export default __webpack_public_path__ + "d5bf0fee2dedf97bd6ef82976c76b99e.svg";